import { ArticleMessagesSettingsTranslation } from 'locales/de/pages/articleMessagesSettings';

const en: ArticleMessagesSettingsTranslation = {
  title: 'Article Reminder Settings',
  templateNameLabel: 'Template Name',
  tabs: {
    lockedDepartments: 'Mandatory Departments',
    mailApplications: 'E-Mail Template Applications',
    articleTemplate: 'E-Mail Template for Articles'
  },
  alerts: {
    templateSaveFailed: 'The template could not be saved.',
    templateSaveSuccessful: 'The template was saved successfully.',
    applicationSaveFailed: 'The application could not be created.',
    applicationSaveSuccessful: 'The application was created successfully.',
    loadError: 'The template could not be loaded.',
    noTemplatesFound: 'No templates were found for this application.'
  },
  subheadings: {
    lockedDepartments: 'Mandatory Departments',
    reminderTemplate: 'E-Mail Template for Reminders',
    applications: 'E-Mail Template Applications'
  },
  lockedDepartmentsDescription: {
    heading: 'Instructions',
    content:
      "Select the departments that must be chosen for the corresponding user group's reminder settings. These departments cannot be deselected by the user."
  },
  lockedDepartmentsSaveWarning: {
    heading: 'Auto-Save',
    content: 'Caution! Changes made here will be saved automatically.'
  },
  templateDescription: {
    heading: 'Template Placeholders',
    content: 'To create the template, you can use the following placeholders.',
    articlesReminder: 'This template is used for the automatic article reminder e-mails.',
    notifyArticle: 'This template is used to notify the recipient of important articles.',
    jobOfferActivation:
      'This template is used for the notification that the job offer has been activated by the recipient.',
    jobmarketNewsletter:
      'This template is used to notify the recipient that new relevant job offers have been published.',
    remindExpiringJob:
      'This template is used for the notification that the job offer expires in 3 days.',
    banEmail:
      "This template is used for the notification that the recipient's company has been blocked for the job market.",
    notifyDisabledCompanyRegistration:
      "This template is used for the automatic reminder e-mails when the recipient's job offer expires.",
    notifyDisabledCompany: 'This template is used for the request to activate a company.',
    approveDisabledCompany: 'This template is used to confirm the activation of a company.',
    invoiceCancelRequest: 'This template is used for the change request from a company.',
    calendarInvite: 'This template is used to confirm a registration for an event.',
    cancelEventGroup: 'This template is used to notify you that an event is not taking place.',
    enrollUser:
      'This template is used for the notification that a place has become free in an event.',
    unenrollUser:
      'This template is used for the notification that the recipient has been removed from the event.',
    cancelEvent: 'This template is used for the notification that an event has been cancelled.',
    community_registrationConfirm:
      'This template is used for the notification that an account has been successfully created in the job market.',
    intoffice_registrationConfirm:
      'This template is used for the notification that an account has been successfully created.',
    community_forgotPassword: 'This template is used to change the password.',
    intoffice_forgotPassword: 'This template is used to change the password.',
    newEntitlements: 'This template is used to confirm that entitlements have been created.',
    incompleteModulesInModuleSelection:
      'This template is used to notify you that module selections with incomplete modules could not be activated.',
    selectionModuleIsNotTakingPlace:
      'This template is used to notify you that a module is not taking place.',
    selectionSignIn:
      'This template is used to notify the recipient that they have been entered in a module.',
    selectionSignInByAdmin:
      'This template is used to notify you that the recipient has been entered in a module by an admin.',
    selectionMoveUp:
      'This template is used to notify the recipient that they have moved up to a module.',
    selectionDischarge:
      'This template is used to notify the recipient that they have unsubscribed from a module.',
    selectionDischargeByAdmin:
      'This template is used to notify you that the recipient has been unsubscribed from a module by an admin.'
  },
  templateVariables: {
    FULLNAME: "Inserts the recipient's full name",
    INTERVAL: 'Inserts the reminder interval in days',
    ARTICLESLIST: 'Inserts the articles of which the recipient should be reminded',
    ARTICLESCOUNT: 'Inserts the number of articles the recipient should be reminded of',
    ARTICLELINK: 'Link to the article',
    ARTICLEHEADLINE: 'Headline of the article',
    OFFERURL: 'Link to the job offering',
    JOBOFFERTITLE: 'Name of the job offering',
    JOBOFFERLINKS: 'List of links to the job offerings',
    BANREASON: 'Reason for blocking the company',
    CONTACTEMAIL: 'Contact email',
    COMPANY: 'Name of the company',
    OFFERID: 'ID of the job offering',
    INVOICEID: 'ID of the invoice',
    STOKNUMBER: 'Stok number',
    CANCELREASON: 'Reason for the change request',
    EVENTTITLE: 'Name of the event',
    EVENTSTARTDATE: 'Start date of the event',
    EVENTPLACE: 'Location of the event',
    EVENTLINK: 'Link to the event',
    EVENTLECTURERNAME: 'Name of the lecturer',
    GROUPTITLE: 'Name of the group',
    EVENTORGANIZER: 'Name of the organizer',
    NEWGROUPINFO: 'Information if you are in a different group',
    EMAIL: "Inserts the recipient's email",
    TOKENURL: 'URL to reset the password',
    EXPIRESIN: 'Date when the link loses its validity',
    ENTITLEMENTS: 'List of created entitlements',
    AWPMLINKS: 'List of AWPM module choices',
    FWPMLINKS: 'List of FWPM module choices',
    SELECTION: 'Name of the selection',
    MODULENAME: 'Name of the module',
    DISCHARGEDBYSTUDENTUNTIL: 'Time until the student call'
  },
  createTemplate: {
    applicationName: 'Name of the application'
  },
  treeViewLabels: {
    locked: 'Mandatory Departments',
    applications: 'E-Mail Template Applications',
    createTemplate: 'Create new mail templates',
    mailTemplates: 'Templates for mail',
    articles: 'Article templates',
    jobmarket: 'Job market templates',
    events: 'Event templates',
    users: 'User templates',
    module_selections: 'Module selection templates',
    access_handler: 'Access handler templates'
  },
  validation: {
    invalidString: 'Value must be a string',
    invalidCharacterLength: 'Value must be 1 or more characters long',
    invalidKey: 'Key must start and end with ### and contain at least 1 character in between'
  }
};

export default en;
